// Import and use some of the 'solid', 'regular', 'light' and 'brand' themes of FontAwesome 5 Free/PRO (.npmrc is required)
// We only add icons to the library that we actually use in frontend to keep the bundle size as small as possible
import { library, dom } from '@fortawesome/fontawesome-svg-core'

// Solid icons
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons/faExclamationTriangle'
import { faChevronRight } from '@fortawesome/pro-solid-svg-icons/faChevronRight'
import { faChevronLeft } from '@fortawesome/pro-solid-svg-icons/faChevronLeft'
import { faChevronUp } from '@fortawesome/pro-solid-svg-icons/faChevronUp'
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons/faChevronDown'
import { faImages } from '@fortawesome/pro-solid-svg-icons/faImages'
import { faInfo } from '@fortawesome/pro-solid-svg-icons/faInfo'
import { faPhone } from '@fortawesome/pro-solid-svg-icons/faPhone'
import { faEnvelope } from '@fortawesome/pro-solid-svg-icons/faEnvelope'
import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck'
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle'
import { faQuoteLeft } from '@fortawesome/pro-solid-svg-icons/faQuoteLeft'
import { faMapMarkerAlt } from '@fortawesome/pro-solid-svg-icons/faMapMarkerAlt'
import { faTimes } from '@fortawesome/pro-solid-svg-icons/faTimes'

// Social Media icons
import { faFacebookF } from '@fortawesome/free-brands-svg-icons/faFacebookF'
import { faTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter'
import { faInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram'
import { faYoutube } from '@fortawesome/free-brands-svg-icons/faYoutube'
import { faPinterest } from '@fortawesome/free-brands-svg-icons/faPinterest'
import { faHouzz } from '@fortawesome/free-brands-svg-icons/faHouzz'
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons/faLinkedinIn'
import { faXing } from '@fortawesome/free-brands-svg-icons/faXing'

// USPs
import { faSmile } from '@fortawesome/pro-light-svg-icons/faSmile'
import { faTags } from '@fortawesome/pro-light-svg-icons/faTags'
import { faPiggyBank } from '@fortawesome/pro-light-svg-icons/faPiggyBank'
import { faStopwatch } from '@fortawesome/pro-light-svg-icons/faStopwatch'
import { faUsers } from '@fortawesome/pro-light-svg-icons/faUsers'
import { faChartLine } from '@fortawesome/pro-light-svg-icons/faChartLine'
import { faSearch } from '@fortawesome/pro-light-svg-icons/faSearch'

// Add imported icons to the library
library.add(
    faExclamationTriangle, faChevronRight, faChevronLeft, faChevronUp, faChevronDown, faImages,
    faImages, faInfo, faPhone, faEnvelope, faCheck, faInfoCircle, faQuoteLeft, faMapMarkerAlt, faTimes,
    faFacebookF, faTwitter, faInstagram, faYoutube, faPinterest, faHouzz, faLinkedinIn, faXing,
    faSmile, faTags, faPiggyBank, faStopwatch, faUsers, faChartLine, faSearch
)

// Kicks off the process of finding <i> tags and replacing with <svg>
dom.watch()
